import { RemoveStorage } from "../../../Utils/Storage";
import { Notification } from "../../../Utils/Notification";
import i18n from "../../../i18n";

const setErrorSnack = async (error) => {
  if (error && error.status) {
    if (401 === error.status || 403 === error.status) {
      RemoveStorage("optime_token");
      RemoveStorage("optime_token");
      return (window.location.href = "/login");
    } else {
      Notification.pushNotif(
        i18n.dir() === "rtl" ? error.data.messageFa : error.data.message,
        "error"
      );
    }
  }
};

export const getCurrentUser = (state, action) => {
  const updateValue = {
    request: action,
    response: null,
    error: null,
  };
  return { ...state, User: { ...updateValue } };
};
export const getCurrentUserSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  if (action.res?.normalizedName !== "WAREHOUSEADMIN") {
    RemoveStorage("ROLE");
    RemoveStorage("BACK_TO_ORG_VALUES");
  }
  return {
    ...state,
    User: { ...updateValue },
    UserRole: action.res?.normalizedName,
  };
};
export const getCurrentUserFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error.response,
  };
  setErrorSnack(action.error.response);
  return { ...state, User: { ...updateValue } };
};

export const userMustLogin = (state, action) => {
  return { ...state, MustLogin: action.state };
};

export const loginUser = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, LoginUser: { ...updateValue } };
};
export const loginUserSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    // response: action.res.entity,
    error: null,
  };

  return {
    ...state,
    LoginUser: { ...updateValue },
    UserRole: action.res.roleName,
  };
};
export const loginUserFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error.response,
  };
  setErrorSnack(action.error.response);
  return { ...state, LoginUser: { ...updateValue } };
};

export const checkUserName = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, checkUserName: updateValue };
};
export const checkUserNameSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };

  return {
    ...state,
    checkUserName: updateValue,
  };
};
export const checkUserNameFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error.response,
  };
  setErrorSnack(action.error.response);
  return { ...state, checkUserName: updateValue };
};

export const loginUserByKey = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, loginByKey: updateValue };
};
export const loginUserByKeySuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };

  return {
    ...state,
    loginByKey: updateValue,
  };
};
export const loginUserByKeyFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  setErrorSnack(action.error.response);
  return { ...state, loginByKey: updateValue };
};

export const getHelpicalTokenKey = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
    loading: true,
  };
  return { ...state, helpicalToken: updateValue };
};
export const getHelpicalTokenKeySuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res,
    error: null,
    loading: false,
  };

  if (action.res.status === 200) {
    Notification.pushNotif(
      i18n.dir() === "rtl" ? "در حال انتقال..." : "redirecting...",
      "success"
    );

    const token = action?.res?.accessToken
    window.location.href = "https://optime.helpical.ir/?login_token=" + token

  } else {
    Notification.pushNotif(
      i18n.dir() === "rtl" ? action.res.messageFa : action.res.message,
      "error"
    );
  }

  return {
    ...state,
    helpicalToken: updateValue,
  };
};
export const getHelpicalTokenKeyFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
    loading: false,

  };
  return { ...state, helpicalToken: updateValue };
};
